import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/pro-regular-svg-icons";
import { faQuestionCircle as faQuestionCircleSolid } from "@fortawesome/pro-solid-svg-icons";
import { Hovercard } from "./hovercard";

// Using font awesome 6 relative sizes...
// can update code when we upgrade to only use the icon size and not the boxSize that cheats.

const sizes = {
    "2xs": {
        boxSize: "10px",
        iconSize: "sm"
    },
    xs: {
        boxSize: "12px",
        iconSize: "sm"
    },
    sm: {
        boxSize: "14px",
        iconSize: "sm"
    },
    md: {
        boxSize: "16px",
        iconSize: "lg"
    },
    lg: {
        boxSize: "20px",
        iconSize: "lg"
    },
    xl: {
        boxSize: "24px",
        iconSize: "lg"
    },
    "2x": {
        boxSize: "32px",
        iconSize: "lg"
    }
};

export function HelpHover({
    title = "",
    body = "",
    size = "lg",
    topOffset = "0",
    leftOffset = "0",
    paddingLeft = "5px",
    paddingRight = "5px",
    solidIcon = false,
    children
}) {
    const { boxSize, iconSize } = sizes?.[size] || { boxSize: "20px", iconSize: "lg" };
    return (
        <Help>
            {children}
            <Hovercard
                header={<ToolTipHeader>{title}</ToolTipHeader>}
                body={body}
            >
                <ToolTipIcon boxSize={boxSize} topOffset={topOffset} leftOffset={leftOffset} paddingLeft={paddingLeft} paddingRight={paddingRight}>
                    <FontAwesomeIcon className="icon" icon={solidIcon ? faQuestionCircleSolid : faQuestionCircle} size={iconSize} />
                </ToolTipIcon>
            </Hovercard>
        </Help>
    );
}

const Help = styled.div`
    display: flex !important;
`;

const ToolTipHeader = styled.div`
    font-family: ${(props) => props.theme.text.medium};
    font-size: ${(props) => props.theme.fontSizeLarge};
`;
const ToolTipIcon = styled.span`
    align-self: flex-end;
    padding-left: ${(props) => props.paddingLeft};
    padding-right: ${(props) => props.paddingRight};
    .icon {
        cursor: pointer;
        position: relative;
        opacity: 0.70;
        top: ${(props) => props.topOffset};
        left: ${(props) => props.leftOffset};
        height: ${(props) => props.boxSize};
        width: ${(props) => props.boxSize};
    }
`;
